<template>
  <main class="main">
    <div class="container">
      <UiBreadCrumbsV2
          :items="[
              {
                title: t('tournaments') || '',
                link: localePath('/tournaments/')
              },
              {
                title: data?.data?.tournamentInfo?.name || '',
                link: localePath('/tournaments/' + route.params.id)
              }
          ]"
      />
      <PagesTounament
          v-model:orderBy="orderBy"
          :categories="data?.data?.tournamentItemCategories || []"
          :info="(data?.data?.tournamentInfo || {}) as TournamentInfo"
          :items="(data?.data?.tournamentItems?.result || []) as AdvancedSearchBody[]"
          :items-length="data?.data?.tournamentItems?.items_length || 0"
          :loading="status === 'pending'"
          :pages-length="data?.data?.tournamentItems?.max_pages || 0"
      />
      <!--      {{ data?.data?.tournamentInfo?.name }}-->
      <!--      {{ route.params.category }}-->
      <!--      <nuxt-link to="/tournaments/2016-mlg-columbus/autograph-capsule">111111</nuxt-link>-->
      <!--      <nuxt-link to="/tournaments/2016-mlg-columbus/sticker">22222</nuxt-link>-->
    </div>
  </main>
</template>

<script lang="ts" setup>
import {AdvancedSearchBody, OrderBy, TournamentInfo} from "~/graphql/generated/schema-types";

definePageMeta({
  key: `tournament`
});

const localePath = useLocalePath()
const {t, locale} = useI18n()
const route = useRoute()

const orderBy = ref<OrderBy>(OrderBy.Alphabetically)
const page = computed(() => {
  return Number(route.query.page) || 1;
});
const category = computed(() => {
  return (route.params.category as string || '').split('-').map(i =>
      i.charAt(0).toUpperCase() + i.slice(1)
  ).join(' ');
});

const {error, data, status} = await useAsyncData('getTournament',
    () => getTournament(page.value, {
      category: category.value || null,
      event_link: route.params.id as string,
      orderBy: orderBy.value
    }, locale.value),
    {watch: [page, orderBy, route]}
);

if (error.value || data?.value?.errors?.length) {
  throw createError({
    status: 404,
    statusText: 'Tournament page error: ' + (error.value?.message || data?.value?.errors?.[0]?.message || '')
  })
}

watch(page, () => {
  if (process.client) {
    window.scrollTo(0, 0)
  }
})


const title = computed(() =>
    t('heads.tournament.title', {name: data.value?.data?.tournamentInfo?.name || ''})
)
const description = computed(() =>
    t('heads.tournament.description', {name: data.value?.data?.tournamentInfo?.name || ''})
)
const weaponIcon = computed(() =>
    getTournamentImage(data.value?.data?.tournamentInfo?.name || '')
)

const {
  alternateLinks,
  canonical
} = useAlternateLinks('/tournaments/' + (route.params.id as string))

useHead({
  title: () => title.value,
  meta: [
    {
      name: "keywords",
      content: "steam, counter strike global offensive, csgo, cs2, skins, items",
    },
  ],
  link: () => alternateLinks.value
})

useSeoMeta({
  title: () => title.value,
  ogTitle: () => title.value,
  description: () => description.value,
  ogDescription: () => description.value,
  ogImage: () => weaponIcon.value,
  twitterCard: 'summary_large_image',
  twitterTitle: () => title.value,
  twitterDescription: () => description.value,
  twitterImage: () => weaponIcon.value,
  ogSiteName: 'CSMarketCap',
  ogUrl: () => canonical.value,
  ogType: 'website',
  ogLocale: () => locale.value
})

const {defineUseProduct} = useDefineProductWithAdvSearchItem()

useSchemaOrg([
  defineItemList({
    id: `itemlist-${title.value.replace(/\s+/g, '-').toLowerCase()}-tournament-page-${locale.value}`, // Уникальный ID для списка
    name: title.value,
    description: description.value,
    image: () => weaponIcon.value,
    itemListElement: await Promise.all(((data?.value?.data?.tournamentItems?.result || []) as AdvancedSearchBody[]).map(async (weapon, index) => {
      const product = await defineUseProduct(weapon);

      return {
        '@type': 'ListItem',
        position: index + 1,
        item: product,
        id: product.id || `item-${index + 1}-${weapon?.market_hash_name}`,
      };
    })),
  }),
  defineBreadcrumb({
    itemListElement: [
      {name: t('main'), item: '/'},
      {name: t('tournaments'), item: '/tournaments'},
      {
        name: title,
        item: localePath('/tournaments/' + (route.params.id as string))
      },
    ],
  })
])
</script>


<style lang="scss" scoped>
.main {
  margin-top: 20px;
}
</style>
